export type SiteData = { revenueToDate: number; agreementsToDate: number };

export const fallbackData: SiteData = {
  revenueToDate: 5500000000,
  agreementsToDate: 150000,
};
